import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useNavigate } from "react-router-dom";
import { useMe } from "@/modules/auth/hooks/useAuth";
import type { UserOrganization } from "@/modules/auth/types";
import { EmptyState } from "@/shared/components/EmptyState";
import { PageHeader } from "@/shared/components/PageHeader";
import { StatusTag } from "@/shared/components/StatusTag";
import { OrganizationFormModal } from "../components/OrganizationFormModal";

const EMPTY_USER_ORGS: UserOrganization[] = [];

export function OrganizationsPage() {
	const navigate = useNavigate();
	const { data: meUser, isLoading } = useMe();
	const userOrganizations = meUser?.organizations ?? EMPTY_USER_ORGS;

	const columns: ColumnsType<UserOrganization> = [
		{
			title: "№",
			key: "index",
			width: 60,
			align: "center",
			render: (_: unknown, __: unknown, index: number) => index + 1,
		},
		{
			title: "Nomi",
			dataIndex: "name",
			key: "name",
			ellipsis: true,
			render: (name: string) => <span className="font-medium text-info">{name}</span>,
		},
		{
			title: "Lavozim",
			dataIndex: "positionName",
			key: "positionName",
			render: (val: string | null) =>
				val ? <span>{val}</span> : <span className="text-ink-faint">—</span>,
		},
		{
			title: "Asosiy",
			dataIndex: "isPrimary",
			key: "isPrimary",
			width: 110,
			align: "center",
			render: (val: boolean) =>
				val ? (
					<StatusTag tone="success">Asosiy</StatusTag>
				) : (
					<StatusTag tone="default">Yo'q</StatusTag>
				),
		},
	];

	return (
		<div>
			<PageHeader title="Mening tashkilotlarim" />

			<Table
				columns={columns}
				dataSource={userOrganizations}
				rowKey="id"
				loading={isLoading}
				pagination={false}
				size="middle"
				locale={{
					emptyText: <EmptyState description="Tashkilot topilmadi" />,
				}}
				onRow={(org) => ({
					onClick: () => navigate(`/organizations/${org.id}`),
					className: "cursor-pointer",
				})}
			/>

			<OrganizationFormModal />
		</div>
	);
}
